import { ComponentProps, FC } from "react";
import { LanguageSelectButton } from "./LanguageSelectButton";
import { BookmarkView } from "./BookmarkView/BookmarkView";
import { DocumentHistoryView } from "./DocumentHistoryView/DocumentHistoryView";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import Fir from "@/assets/images/fir.svg";

type MenuButtonViewProps = ComponentProps<typeof LanguageSelectButton> & {
  firLink?: string;
};
export const MenuButtonView: FC<MenuButtonViewProps> = ({ firLink }) => {
  return (
    <div className="flex space-x-2">
      <BookmarkView />
      <DocumentHistoryView />
      {firLink && (
        <Button className="h-10 w-10 p-0" variant="ghost">
          <Link className="flex items-center hover:underline" to={firLink} target="_blank">
            <img src={Fir} alt={""} />
          </Link>
        </Button>
      )}
    </div>
  );
};
